import { Subject } from 'rxjs';
import { isLoadingState } from './../core/store/general/selectors';
import { IUser } from './../core/models/user.model';
import { AuthService } from './../core/services/auth.service';
import { AuthState } from './../core/store/auth/auth.reducer';
import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { Sandbox } from '../core/facade/sandbox';
import { Router } from '@angular/router';
import { GeneralState } from './../core/store/general/state';
import { environment } from '../../environments/environment';
import { SocialAuthService } from 'angularx-social-login';


@Injectable()
export class AppState extends Sandbox {

  public isLoggedIn$;
  public isLoading$;
  public webSocket;
  adminUrl = environment.adminUrl;

  constructor(protected appState$: Store<AuthState>,
              private auth: AuthService,
              public generalState$: Store<GeneralState>,
            protected router: Router,
            protected socialAuth: SocialAuthService) {
    super(appState$, generalState$, auth, router, socialAuth);

    this.isLoggedIn$ = this.loggedUser$;
    this.generalState$.select(isLoadingState).subscribe(arg => this.isLoading$ = arg);
    this.initializeWebSocketConnection();

  }

  public userLoggedInSub = new Subject<boolean>();
  public userLoggedIn$ = this.userLoggedInSub.asObservable();

  /**
   * Dispatches login action
   *
   * @param form
   */
  public login(email: string, password: string): void {
      this.auth.login(email, password)
      .subscribe(
        userInfo => {
          const loggedInUser: IUser = {
            email: userInfo['email'],
            id: userInfo['id'],
            name: userInfo['name'],
            surname: userInfo['surname'],
            username: userInfo['username']
          };
          this.isLoggedIn$ = true;
          this.userLoggedInSub.next(true);
          console.log(loggedInUser);
          super.loginUser(loggedInUser);

        },
        (error) => {
          console.log(error.error);
          alert(error.error);
        }
    );

  }

  register(user) {
    if (!this.isLoggedIn$) {
      this.auth.register(user).subscribe(userInfo => {
        this.login(user['email'], user['passwd']);
      },
      (error) => {
        console.log(error);
        alert('User already exists!');
      });
    }
  }

  logout() {
    super.logoutUser();
  }

  socialLogin(social) {
    this.auth.socialLogin(social, window.location.pathname).subscribe(
      reply => {
        const childWin = window.open(reply.toString(), '_self');
        console.log(reply);
      },
      error => {
        console.log('oops', error.error.text);
        window.open(error.error.text.toString(), '_self');
      }
    );
  }

  initializeWebSocketConnection() {
    if (this.webSocket && this.webSocket.readyState !== this.webSocket.CLOSED) {
      this.writeResponse('WebSocket is already opened.');
      // return;
    }  else if (this.isLoggedIn$)  {

        try {
            // get the right websocket protocol
            const wsProtocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
            const wsUrl = 'wss://' + this.adminUrl + '/messaging';
            // Create a new instance of the websocket
            this.webSocket = new WebSocket(wsUrl);

            /**
             * Binds functions to the listeners for the websocket.
             */
            this.webSocket.onopen = (event) => {
                // For reasons I can't determine, onopen gets called twice
                // and the first time event.data is undefined.
                // Leave a comment if you know the answer.
                console.log(event);
                console.log('CONNECTED');
                if (event.data === undefined) {return; }
                console.log('socket is open');
                this.writeResponse(event.data);
            };

            this.webSocket.onmessage = (event) => {
                console.log(event.data);
                this.writeResponse(event.data);
            };

            this.webSocket.onclose = (event) => {
                this.writeResponse('Connection closed');
                console.log('socket is closed');
            };

            this.webSocket.onerror = (event) => this.onError(event);

        } catch (error) {
            // console.log(error)
        }
    }
  }
  // onOpen(evt)   { console.log('CONNECTED'); console.log(evt); }


  writeResponse(json) {
      try {
        if ('Connection closed' === json) { return; }
        console.log(json);
          const response = JSON.parse(json);
          console.log(response);
          // let output;
          // Determine the type of message recieved and handle accordingly
          switch (response.type) {
              case 'text':
                  /*setTimeout(function() {
                      if (window.sessionStorage.user) {
                          var user = JSON.parse(window.sessionStorage.user);
                          $.ajax({
                              method: "GET",
                              url: '../webresources/frontend/entity.messagethread/user/unread/' + user.id,
                          }).done(function (count) {
                              $("#right-nav #messages span").text(count);
                              $("#navBar>#messages span").text(count);
                              user.unreadMessages = count;
                              window.sessionStorage.user = JSON.stringify(user);
                          }).fail(function () {

                          });
                      }
                  }, 1000);
                  Backbone.trigger('messageThreads:update');*/
                  break;
              case 'users':
                  /*if (response.users.length > 0) {
                    app.connectedUsers = response.users.split(';');
                  }*/
                  break;
              case 'online': /*
                  if($('#userlist').length)
                      $('#userlist').append($('<option></option>').attr('value', response.user).text(response.user));
                    app.connectedUsers.push(response.user);*/
                  break;
              case 'offline': /*
                  if($('#userlist').length)
                      $('#userlist option[value="'+response.user+'"]').remove();

                  var idx = app.connectedUsers.indexOf(response.user);
                  if(idx>-1)
                      app.connectedUsers = app.connectedUsers.splice(idx+1,1);*/
                  break;
          }
      } catch (error) {
          console.log(error);
      }
  }

onError(evt)  {
  this.writeToScreen('<span style="color: red;">ERROR:</span> ' + evt.data);
}

doSend(message)  {
  this.writeToScreen('SENT: ' + message);
  this.webSocket.send(message);
}

writeToScreen(message)  {
  const pre = document.createElement('p');
  pre.style.wordWrap = 'break-word';
  pre.innerHTML = message;
  // output.appendChild(pre);
}

  onMessage(evt)  {
    this.writeToScreen('<span style="color: blue;">RESPONSE: ' + evt.data + '</span>');
    // this.webSocket.close();
  }

  /**
   * Dispatches reset password action
   *
   * @param form
   */
  public resetPassword(form: any): void {

  }
}
